/**
 * FieldLabel — small uppercase label rendered above an input. Used INSTEAD
 * of MUI floating labels for paper-form-traceable surfaces, so the field
 * structure visually matches the source paper form.
 *
 * Pass `required` to add the * marker. Pass `hint` to add a muted inline
 * sub-label (e.g. for example values or AISC clause references).
 * Pass `htmlFor` to render a real <label> tied to that input id, and `id` so a
 * select can name it with aria-labelledby (accessibility).
 */

import React from "react";
import { Typography } from "@mui/material";
import { FIELD_LABEL, FIELD_HINT } from "./styles";

export default function FieldLabel({ children, required = false, hint, sx, htmlFor, id }) {
  const asLabel = htmlFor ? { component: "label", htmlFor } : {};
  return (
    <Typography id={id} {...asLabel} sx={{ ...FIELD_LABEL, ...(htmlFor ? { display: "block" } : {}), ...sx }}>
      {children}
      {required && (
        <Typography component="span" sx={{ color: "error.main", ml: 0.25 }}>
          *
        </Typography>
      )}
      {hint && (
        <Typography component="span" sx={FIELD_HINT}>
          · {hint}
        </Typography>
      )}
    </Typography>
  );
}
